import ItemSelector from "./ItemSelector"
import { useContext } from "react"
import CatalogBrowserContext from "./CatalogBrowserContext"
import { ConfigProvider } from "antd"

const CatalogBrowser = () => {
  const {addCatalogItem, addTemplate, allowDragging, isCatalogBrowserOpen, toggleCatalogBrowser} = useContext(CatalogBrowserContext)

  const width = isCatalogBrowserOpen ? '300px' : '0px'
  const innerWidth = isCatalogBrowserOpen ? '290px' : '0px'

  return <div style={{width, height: '100%', marginLeft: '-1em', transition: 'width 250ms ease-in-out'}}>
    <div style={{position: 'fixed', top: 0, zIndex: '98'}}>
      <div style={{width: innerWidth, transition: 'width 250ms ease-in-out', overflow: 'hidden', backgroundColor: '#ddd', height: '100vh'}}>
        <div style={{padding: '0 5px'}}>
          <ConfigProvider theme={{
            components: {
              Table: {
                colorBgContainer: '#eee'
              },
              Tabs: {
                colorBgContainer: '#eee'
              }
            }
          }}>
            <ItemSelector
              onAdd={addCatalogItem}
              onClose={toggleCatalogBrowser}
              onTemplateAdd={addTemplate}
              draggable={allowDragging}
              fixedHeight="calc(100vh - 60px)"
              docked />
            </ConfigProvider>
          </div>
        </div>
      </div>
    </div>
}

export default CatalogBrowser